import { createFileRoute } from '@tanstack/react-router'

import { WorkflowRunsPage } from '#/modules/ai/back-office/runs-page/workflow-runs-page.tsx'
import { requirePermissions } from '#/shared/routing/require-permissions.ts'

export const Route = createFileRoute('/bo/ai/runs/$workflowId')({
  beforeLoad: (options) => requirePermissions(options, ['aiAnalysis.review.read']),
  component: function Component() {
    const { workflowId } = Route.useParams()
    return <WorkflowRunsPage workflowId={workflowId} />
  },
})
